import { useQuery } from '@tanstack/react-query';

import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

export interface InspectionsResponse {
  data: any[];
}

export const getInspections = async ({
  shipmentId,
  makeRequest,
}: {
  shipmentId: string;
  makeRequest: any;
}): Promise<InspectionsResponse> => {
  const { data, error } = await makeRequest({
    path: `/inspection/shipments/${shipmentId}/tickets`,
  });

  if (error) {
    throw new Error(error);
  }

  return data.tickets;
};

type QueryFnType = typeof getInspections;
type UseGetInspectionsOptions = {
  shipmentId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useInspections = ({
  shipmentId,
  config,
}: UseGetInspectionsOptions) => {
  const [, makeRequest] = useImperativeRequestWrapper('shipmentV3');

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['security-inspections', shipmentId],
    queryFn: () => getInspections({ shipmentId, makeRequest }),
  });
};
